(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-flash-deal-timer"] && !Shopify.designMode) return;
  try {
    class CsFlashTimer extends HTMLElement {
    #tid = null;
    #endTime = 0;

    connectedCallback() {
      const pad = (n) => String(n).padStart(2, '0');
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
      const parts = fmt.formatToParts(new Date());
      const y = parts.find(p => p.type === 'year').value;
      const mo = parts.find(p => p.type === 'month').value;
      const d = parts.find(p => p.type === 'day').value;
      const isPDT = new Date(`${y}-${mo}-${d}T12:00:00-07:00`)
        .toLocaleString('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', hour12: false }) === '12';
      const offset = isPDT ? '-07:00' : '-08:00';
      this.#endTime = new Date(`${y}-${mo}-${d}T23:59:59${offset}`).getTime();

      const timeEl = this.querySelector('.cs-flash-timer__time');
      if (!timeEl) return;

      const tick = () => {
        const diff = this.#endTime - Date.now();
        if (diff <= 0) {
          this.style.display = 'none';
          clearInterval(this.#tid);
          return;
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        timeEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
      };

      tick();
      this.#tid = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.#tid);
    }
  }

  if (!customElements.get('cs-flash-timer')) {
    customElements.define('cs-flash-timer', CsFlashTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
